import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface OrgMember {
  id: string;
  user_id: string;
  email: string;
  full_name: string | null;
  rol: string;
  created_at: string;
}

export function useOrgMembers() {
  const { orgId } = useAuth();

  return useQuery({
    queryKey: ["org-members", orgId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_org_members_with_email", {
        _org_id: orgId!,
      });
      if (error) throw error;
      return (data ?? []) as OrgMember[];
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}
